import {reach} from 'hoek';

/**
 *
 * @param {Array} allCategories
 * @param {String} chain https://github.com/hapijs/hoek/blob/master/API.md#reachobj-chain-options
 * @param {String} value value for comparison against returned value from category
 */

const categoryLookup = (allCategories, chain, value) => {
    const filtered = allCategories.filter(
        (category) => reach(category, chain) === value,
    );
    if (filtered.length > 1) {
        return filtered;
    }
    return filtered[0];
};

/**
 *
 * @param {Array} allCategories
 * @param {Object} homeCrumb {name: String}, url: String}
 * @param {Object} category
 * @param {Object} [article = {}] (optional)
 */

const getBreadcrumbs = (allCategories, homeCrumb, category, article = {}) => {
    const homeRoute = homeCrumb.url;
    const crumbs = [];
    let current = category;
    while (current) {
        crumbs.unshift({
            name: current.name,
            url: `${homeRoute + current.path}`,
        });
        current = categoryLookup(allCategories, 'sys.id', current.parentId);
    }
    crumbs.unshift(homeCrumb);

    if (article && article.headline) {
        const words = article.headline.split(' ');
        const name =
            words.length > 4
                ? `${words.filter((w, i) => i < 4).join(' ')}...`
                : article.headline;
        crumbs.push({
            name,
            url: `${homeRoute + category.path}/${article.slug}`,
        });
    }

    return crumbs;
};

const sortByMostRecent = (arr) => {
    const cloneArr = [...arr];

    cloneArr.sort((x, y) => {
        const firstDate = new Date(x.datePublishedCustom);
        const secondDate = new Date(y.datePublishedCustom);
        return secondDate - firstDate;
    });

    return cloneArr;
};

/**
 *
 * @param {Object} node A Contentful text node
 * @returns {String} A hash to be used as an ID or anchor link
 */

const createHashFromUnderline = (node) => {
    const underline = node.content.filter((type) => {
        return (
            type.marks &&
            type.marks.length > 0 &&
            type.marks[0].type === 'underline'
        );
    });
    const value = underline[0] && underline[0].value;
    return (
        (value && {
            hash: value.replace(/\s+/g, '-').toLowerCase(),
            label: value.charAt(0).toUpperCase() + value.slice(1),
        }) ||
        null
    );
};

export {
    getBreadcrumbs,
    categoryLookup,
    sortByMostRecent,
    createHashFromUnderline,
};
